import Paper from '@mui/material/Paper';
import { TextField, Button } from '@mui/material';
import { useState } from 'react';
import axios from "axios";
import React from 'react';
import PeerGroupList from './PeerGroupList';
import AddCompany from './AddCompany';
import AddPeer from './AddPeer';
import PeerAssignment2 from './PeerAssignment2_BAK';
import EditPeer from './EditPeer';
import PeersAssigned from './PeersAssigned';
import PeerAssignCompany from './PeerAssignCompany';



function Peers(props) {
    //I think most of these need to go up into the app.js
    //I need a state for peerCompanies and that gets passed into the PeersAssigned component and the PeerAssignCompany components so when I assign a compnay I can update the state
    const [peerGroups, setPeerGroups] = useState([{}]);
    const [selectedPeerGroupId, setSelectedPeerGroupId] = useState(0);
    const [selectedPeer, setSelectedPeer] = useState({});
    //const [allCompanies, setAllCompanies] = useState([{}]);
    const [peerCompanies, setPeerCompanies] = useState([{}]);

    function refreshPeers() {
        //Hook up to load up the peergroups
        axios({
            // Endpoint to send files
            url: process.env.REACT_APP_API_URL + 'peergroups',
            method: "Get",
            data: {},
        }).then((res) => {
            setPeerGroups(res.data);
        }).catch((err) => {
            console.log(err)
        });
    }

    //Hooks up to the launch of the page
    React.useEffect(() => {
        refreshPeers();
        //refreshCompanies();
    }, []);

    const companyAdded = (e)=>
    {
        //refreshCompanies();
        props.setAllCompanies(e);
    }

    // function refreshCompanies() {
    //     axios({
    //         // Endpoint to send files
    //         url: process.env.REACT_APP_API_URL + 'Company',
    //         method: "Get",
    //         data: {},
    //     }).then((res) => {
    //         setAllCompanies(res.data);
    //         console.log("All companies:", res.data);
    //     }).catch((err) => {
    //         console.log(err)
    //     });
    // }

    // Fetch companies assigned to the selected peer group
    const fetchPeerGroupCompanies = (peerGroupId) => {
        console.log("Fetching companies for peer group:", peerGroupId);
        if (!peerGroupId || peerGroupId <= 0) {
            setPeerCompanies([]);
            return;
        }
        
        axios({
            url: process.env.REACT_APP_API_URL + `PeerGroup/${peerGroupId}`,
            method: "Get",
        })
        .then((res) => {
            setPeerCompanies(res.data);
            console.log("Companies in peer group:", res.data);
        })
        .catch((err) => {
            setPeerCompanies([]);
        });
    };

    // Update selected peer and fetch companies when peer group ID changes
    React.useEffect(() => {
        //find the peer group
        setSelectedPeer(peerGroups.find((i) => i.peerGroupId === selectedPeerGroupId));
        // Fetch the companies in the peer group
        fetchPeerGroupCompanies(selectedPeerGroupId);
    }, [selectedPeerGroupId, peerGroups]);

    if (selectedPeerGroupId > 0) {
        return (
            <>
                <div className='container'>
                    <h4>Peer Management</h4>
                    <div className='formRow'>
                        <EditPeer selectedPeer={selectedPeer} setSelectedPeer={setSelectedPeer} setSelectedPeerGroupId={setSelectedPeerGroupId} refreshPeers ={refreshPeers}></EditPeer>
                    </div>
                    <div className='formRow'>
                        <div className='formGroup'>
                            <PeersAssigned
                                selectedPeerGroupId={selectedPeerGroupId} setSelectedPeerGroupId={setSelectedPeerGroupId}
                                peerCompanies={peerCompanies} setPeerCompanies={setPeerCompanies}
                                peerGroup={selectedPeer} setPeerGroup={setSelectedPeer}
                                allCompanies={props.allCompanies} setAllCompanies={props.setAllCompanies}
                            ></PeersAssigned>
                        </div>
                        <div className='formGroup' style={{}}>
                            <PeerAssignCompany selectedPeerGroupId={selectedPeerGroupId} setSelectedPeerGroupId={setSelectedPeerGroupId}
                                allCompanies={props.allCompanies} setAllCompanies={props.setAllCompanies}
                                peerCompanies={peerCompanies} setPeerCompanies={setPeerCompanies}
                            ></PeerAssignCompany>
                        </div>
                    </div>
                </div>
            </>
        );
    } else {
        return (
            <>
                <div className='container'>
                    <h4>Peer Management</h4>
                    <div className='formRow'>
                        <div className='formGroup'>
                            <AddPeer refreshList={refreshPeers}></AddPeer>
                        </div>
                        <div className='formGroup'>
                            <AddCompany setNewCompany={companyAdded} setAllCompanies = {props.setAllCompanies} allCompanies={props.allCompanies}></AddCompany>
                        </div>
                    </div>

                    <div className='formRow'>
                        <div className='formGroup'>
                        </div>
                        <div className='formGroup'>
                            <PeerGroupList 
                                peerGroups={peerGroups} 
                                selectedPeerGroupId={selectedPeerGroupId} 
                                setSelectedPeerGroupId={setSelectedPeerGroupId}
                            ></PeerGroupList>
                        </div>
                        <div className='formGroup'></div>
                    </div>
                </div>
            </>
        );
    }
}

export default Peers;